/* eslint-disable react/jsx-no-target-blank */
import { useEffect, useRef } from 'react'

function FornitoriDetails({ fornitore, flag2 }) {
    const details = { display: 'grid', gridTemplateColumns: '0.20fr .5fr', gap: '5px' }
    const videoPreview = useRef()
    useEffect(() => {
        if (fornitore.descrizione) {
            document.getElementById('descr').innerHTML = fornitore.descrizione
        }
    }, [fornitore])

    useEffect(() => {
        if (flag2 !== 'fornitoriDetails') {
            if (fornitore.video) {
                const lp = videoPreview.current
                lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
            }
        }
    }, [flag2])

    return (<>
        <div className='visualDettagli' style={{ top: `${flag2 === 'fornitoriDetails' ? '0' : '120%'}` }}>
            {fornitore &&
                <div className='mt-3 mb-5'>
                    <div style={{ cursor: 'pointer', float: 'right' }} onClick={() => {
                        if (fornitore.video) {
                            const lp = document.getElementById('videoPreview')
                            lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
                        }
                        window.history.back()
                    }}>
                        <img src={require('../../../userNotAuth/image/icons8-chiudi-macos-32.png')} width={40} alt='' />
                    </div><br />
                    <div className='bodyPadding mt-3 fs-6'>
                        {fornitore.img &&
                            <img src={`https://leuro-bucket.s3.amazonaws.com/${fornitore.img.split(',')[0]}`}
                                style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '50%' }} alt='' />
                        }
                        {/* ----------------- NOME AZIENDA ------------------ */}
                        {fornitore.gruppo &&
                            <div className='fs-3 fw-semibold mt-3'><b>{fornitore.gruppo.toUpperCase()}</b></div>
                        }
                        {/* ------------------------- CITTA' E REGIONE ------------------------ */}
                        {fornitore.regione &&
                            <div className='fs-5 text-success'>{fornitore.regione}
                                {fornitore.città && <span> - {fornitore.città}</span>}
                            </div>
                        }
                        {/* -------------------- NOME E COGNOME ------------------- */}
                        {fornitore.nome &&
                            <div className='mt-3' style={details}><div>NOME: </div><div>{fornitore.nome} </div></div>
                        }
                        {/* ----------------------- GENERE ------------------------------ */}
                        <div style={details}><div>TIPO:</div> <div>{fornitore.genere}</div> </div>
                        {fornitore.cachet &&
                            <div style={details}><div>Cachet:</div><div> € {fornitore.cachet}</div>
                            </div>
                        }
                        {/* --------------------- TELEFONO ---------------------- */}
                        {fornitore.telefono &&
                            <div style={details}>
                                <div><img src={require('../../../userNotAuth/image/icons8-telefono-cellulare-48.png')} width='25em' alt='' /></div>
                                <div>{fornitore.telefono}</div>
                            </div>
                        }
                        {/* -------------------------- EMAIL --------------------- */}
                        {fornitore.emailUser &&
                            <div style={details}>
                                <div><img src={require('../../../userNotAuth/image/icons8-nuovo-messaggio-48.png')} width='25em' alt='' /></div>
                                <div>{fornitore.emailUser}</div>
                            </div>
                        }
                        {/* ---------------------------- DESCRIZIONE --------------------- */}
                        <p style={{ border: '2px solid lightblue', fontWeight: '500', backgroundColor: '#fffcfc', padding: '20px 10px', margin: '2em 0' }}>
                            <p className='text-center fs-5 text-secondary'><i>{fornitore.genere}</i></p>
                            <p className='fs-5 d-inline' id="descr"></p>
                        </p>
                        {/* ----------------------------- LINK ---------------------- */}
                        <div style={{ border: '1px solid lightgrey', borderRadius: '15px', padding: '15px 10px', marginTop: '1em' }}>
                            <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                            {fornitore.url &&
                                <div className='btn btn-warning'>
                                    <a href={fornitore.url} style={{ textDecoration: 'none', color: 'navy', display: 'inline' }} target='_blank'>Sito web</a>
                                </div>
                            }
                            {fornitore.fb &&
                                <a className='ms-2' href={fornitore.fb} target='_blank'>
                                    <img src={require('../../../userNotAuth/image/icons8-fb-48.png')} alt='' />
                                </a>
                            }
                            {fornitore.youtube &&
                                <a className='ms-2' href={fornitore.youtube} target='_blank'>
                                    <img src={require('../../../userNotAuth/image/icons8-instagram-48.png')} alt='' />
                                </a>
                            }
                            {!fornitore.url && !fornitore.fb && !fornitore.youtube && <span><i>nessun link presente</i></span>}
                        </div>
                        {/* ---------------------- FOTO ----------------------- */}
                        {fornitore.img &&
                            <div className='row mt-3'>
                                {fornitore.img.split(',').map((img, index) => (
                                    <div key={index} className="card mt-3"
                                        style={{
                                            width: '20rem', height: '100%',
                                            padding: '0px',
                                            margin: '0 auto',
                                            border: '3px solid gainsboro',
                                        }}>
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${img}`} style={{ objectFit: 'cover' }} width='100%' alt='' />
                                    </div>
                                ))}
                            </div>
                        }
                        {/* ------------------------ VIDEO ------------------------ */}
                        {fornitore.video &&
                            <div className='text-center mt-5'>
                                <video src={`https://leuro-bucket.s3.amazonaws.com/video/${fornitore.video}`} ref={videoPreview}
                                    style={{ width: '99%', maxHeight: '200px', borderRadius: '5px' }} controls />
                            </div>
                        }
                    </div>
                    <button className='mt-5 btn btn-secondary' onClick={() => {
                        if (fornitore.video) {
                            const lp = videoPreview.current
                            lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
                        }
                        window.history.back()
                    }}>Indietro</button>
                </div>
            }
        </div>
    </>)
}
export default FornitoriDetails